import { Box, Divider, Typography } from '@mui/material'
import { memo } from 'react'
import { RuleDescription, RuleHeader } from '../rulesElements/elements'
import RuleInfoItem from '../rulesElements/RuleInfoItem'

const DescriptionOnly = memo(({ dataQuestion }) => {
  const isGE = dataQuestion?.type_code_original === 'GE'

  if (isGE && !dataQuestion?.cara_pengerjaan) {
    dataQuestion.cara_pengerjaan =
      'PETUNJUK DAN CONTOH UNTUK KELOMPOK SOAL (No. 61 - 76)\n\n' +
      'Ditentukan dua kata.\n' +
      'Carilah satu perkataan yang meliputi pengertian kedua kata tadi\n' +
      'Tulislah perkataan itu pada lembar jawaban dibelakang nomor soal yang sesuai.\n\n' +
      'Contoh :\n' +
      'Ayam - Itik\n\n' +
      'Perkataan "Burung" dapat meliputi pengertian dua kata itu.\n' +
      'Maka jawabannya ialah "Burung"\n' +
      'Oleh karena itu, pada lembar jawaban di belakang contoh : Harus ditulis "burung"\n\n' +
      '(04) burung\n\n' +
      'Gaun - Celana\n\n' +
      'Pada contoh ini jawabannya ialah "Pakaian" maka "Pakaian" yang seharusnya ditulis.\n\n' +
      'Carilah selalu perkataan yang tepat dapat meliputi pengertian kedua kata itu.'
  }

  return (
    <Box display="flex" flexDirection="column" height="100%" mx="-1rem">
      <Box
        bgcolor="#9AA5EA"
        width="100%"
        px={2}
        py={1}
        minHeight={1}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      />
      <Box
        py={2}
        bgcolor={({ palette }) => palette['background'].default}
        position={'sticky'}
        top={0}
        sx={{
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          zIndex: 2,
        }}
      >
        <RuleHeader>
          {dataQuestion?.type_name} ({dataQuestion?.type_code_original})
        </RuleHeader>
      </Box>
      <Divider />
      <Box>
        <RuleInfoItem
          timer={dataQuestion?.waktu}
          amount={dataQuestion?.jumlah_soal}
          type={dataQuestion?.type_sub_modul_original}
        />
        <Box width={'100%'} mb={3}>
          <Typography fontWeight={700}>Deskripsi</Typography>
          <RuleDescription variant="body1" mt={2} sx={{ textAlign: 'justify' }}>
            {dataQuestion?.deskripsi}
          </RuleDescription>
        </Box>
        {dataQuestion?.cara_pengerjaan && isGE && (
          <Box
            width={'100%'}
            mb={3}
            p={2}
            sx={{
              bgcolor: '#EEF4FF',
              borderRadius: '14px',
              border: '1px solid #D6E4FF',
            }}
          >
            <Typography fontWeight={700} mb={1}>
              Cara Pengerjaan
            </Typography>

            <RuleDescription
              variant="body1"
              sx={{
                whiteSpace: 'pre-line',
              }}
            >
              {dataQuestion?.cara_pengerjaan}
            </RuleDescription>
          </Box>
        )}
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default DescriptionOnly
